import axios from 'axios';
import utils from '../utils';
export default {
    load: function load(options) {
        return new Promise(function (resolve) {
            var cameras = [];
            var makeurl = function makeurl() {
                var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/api/channels';
                var additional_params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var url_params = [];
                for (var key in additional_params) {
                    if (additional_params.hasOwnProperty(key)) {
                        url_params.push(''.concat(key, '=').concat(encodeURIComponent(additional_params[key])));
                    }
                }
                return ''.concat(options.proto || '//').concat(options.host).concat(options.port ? ':' + options.port : '').concat(path).concat(url_params.length != 0 ? '?' + url_params.join('&') : '');
            };
            var read_or_create_jwt = function read_or_create_jwt(callback) {
                var token = localStorage.getItem('jwt');
                var exp = token ? require('jsonwebtoken').decode(token).exp : null;
                if (exp * 1000 < Date.now()) {
                    var headers = { 'Content-Type': 'application/json' };
                    var payload = {
                        'username': options.user,
                        'password': options.password
                    };
                    axios.post(makeurl('/api/auth/login'), payload, { headers: headers }).then(function (res) {
                        localStorage.setItem('jwt', res.data.token);
                        callback(res.data.token);
                    });
                } else {
                    callback(token);
                }
            };
            if (options.user && options.password) {
                read_or_create_jwt(function (token) {
                    var headers = {
                        'Authorization': 'Bearer '.concat(token),
                        'Content-Type': 'application/json'
                    };
                    axios.get(makeurl(), { headers: headers }).then(function (res) {
                        var channels = [options.channels === 0 && [0] || options.channels || []].reduce(function (flat, current) {
                            return flat.concat(current);
                        }, []);
                        cameras = [].concat.apply([], res.data).map(function (val, index) {
                            if (channels.length == 0 || channels.indexOf(index) >= 0 || channels.indexOf(val.name) >= 0) {
                                return {
                                    name: utils.makevalue(options.name, index, val.name),
                                    image: utils.makevalue(options.image, index),
                                    quality: [
                                        {
                                            name: 'HD',
                                            url: makeurl('/api/hls/playlist', {
                                                src: val['marker'],
                                                stream: 0,
                                                onlyKeyFrames: false
                                            })
                                        },
                                        {
                                            name: 'SD',
                                            url: makeurl('/api/hls/playlist', {
                                                src: val['marker'],
                                                stream: 1,
                                                onlyKeyFrames: false
                                            })
                                        }
                                    ]
                                };
                            }
                        }).filter(function (x) {
                            return x;
                        });
                        resolve(cameras);
                    });
                });
            }
            if (options.marker) {
                var channels = [options.marker || []].reduce(function (flat, current) {
                    return flat.concat(current);
                }, []);
                cameras = [].concat.apply([], channels).map(function (val, index) {
                    return {
                        name: utils.makevalue(options.name, index),
                        image: utils.makevalue(options.image, index),
                        quality: [
                            {
                                name: 'HD',
                                url: makeurl('/api/hls/playlist', {
                                    src: val,
                                    stream: 0,
                                    onlyKeyFrames: false
                                })
                            },
                            {
                                name: 'SD',
                                url: makeurl('/api/hls/playlist', {
                                    src: val,
                                    stream: 1,
                                    onlyKeyFrames: false
                                })
                            }
                        ]
                    };
                }).filter(function (x) {
                    return x;
                });
                resolve(cameras);
            }
        });
    }
};